import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '../components/Icon';
import { faPlugCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { Empty } from '../components/ui';
import { useI18n } from '../lib/i18n';

export default function NotFound() {
  const { t } = useI18n();
  return (
    <div className="shell py-16">
      <Empty>
        <FontAwesomeIcon icon={faPlugCircleXmark} className="mb-3 text-5xl text-slate-300" />
        <h1 className="text-2xl font-extrabold text-ink">{t('Page not found')}</h1>
        <p className="mt-1">{t("The page you are looking for doesn't exist.")}</p>
        <Link to="/shop" className="btn btn-primary mt-5">{t('Browse products')}</Link>
      </Empty>
    </div>
  );
}
